import { Translate } from 'next-translate';
import { NextRouter } from 'next/router';

import { impersonate, signOut, stopImpersonating } from '@api/AuthApi';
import Routes from '@services/Routes';
import { alertMessage } from '@utils/common';

import { User } from './types';

interface Props {
  key: string;
  router: NextRouter;
  t: Translate;
  user: User;
}

export const handleOptionClick = ({ key, user, router, t }: Props) => {
  if (key === 'signout') {
    signOut().then(response => {
      if (response.status !== 204) return;

      user.clearUserData();
      router.push('/login');
    });
  }

  if (key === 'stop-impersonating') {
    stopImpersonating().then(results => {
      if (results?.response?.data?.errors) {
        alertMessage(results.response.data.errors[0], 'error', 6);
        return;
      }

      alertMessage(t('general.no_longer_impersonating'));
      window.location.href = Routes.SUPER_ROOT_PATH;
    }).catch(() => {
      alertMessage(t('errors.stop_impersonating_settings'), 'error', 6);
    });
  }

  if (key.startsWith('impersonate-user-')) {
    const currentKeyId = key.replace('impersonate-user-', '');

    impersonate({ user_id: currentKeyId }).then(results => {
      if (results?.response?.data?.errors) {
        alertMessage(results.response.data.errors[0], 'error', 6);
        return;
      }

      alertMessage('Switched Users');

      window.location.href = Routes.ROOT_AUTHENTICATED_PATH;
    }).catch(() => {
      alertMessage('There was an error while trying to switch users to impersonate.', 'error', 6);
    });
  }
};
